import { initializeApp, getApps } from "firebase/app";
import { getAuth } from "firebase/auth";
import { initializeFirestore, getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

/**
 * CONFIGURAÇÃO DO FIREBASE PARA VITE + REACT
 *
 * experimentalAutoDetectLongPolling: redes 4G/CGNAT/proxy quebram QUIC/WebChannel;
 * o SDK troca sozinho para long polling quando detecta falha.
 */

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];

function createDb() {
  try {
    return initializeFirestore(app, {
      experimentalAutoDetectLongPolling: true,
    });
  } catch {
    // App hot-reload / já inicializado
    return getFirestore(app);
  }
}

export const auth = getAuth(app);
export const db = createDb();
export const storage = getStorage(app);

export default app;
